import { render, staticRenderFns } from "./BannerTitle.vue?vue&type=template&id=466bdcd8&scoped=true&"
import script from "./BannerTitle.vue?vue&type=script&lang=js&"
export * from "./BannerTitle.vue?vue&type=script&lang=js&"
import style0 from "./BannerTitle.vue?vue&type=style&index=0&id=466bdcd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466bdcd8",
  null
  
)

export default component.exports